import script from "./StepFour.vue?vue&type=script&setup=true&lang=js"
export * from "./StepFour.vue?vue&type=script&setup=true&lang=js"

import "./StepFour.vue?vue&type=style&index=0&id=3fdc1abe&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fdc1abe"]])

export default __exports__